import Axios from "../../configs/axios.config";

export const createHoliday = (data) => Axios.post(`/holiday`, data).then(response => response.data.data);
export const updateHoliday = ( data, id) => Axios.put(`/holiday/${id}`, data);
export const getHolidayList = (data) => Axios.get('/holiday', { params: data }).then(response => response.data);
export const getHolidayDetail = (id) => Axios.get(`/holiday/${id}`).then(response => response.data.data);
export const deleteHoliday = (id) => Axios.delete(`/holiday/${id}`);

// /Events
export const createEvent = (data) => Axios.post(`/event`, data).then(response => response.data.data);
export const updateEvent = (data, id) => Axios.put(`/event/${id}`, data).then(response => response.data.data);
export const getEventList = (data) => Axios.get('/event', { params: data }).then(response => response.data.data);
export const getEventDetail = (id) => Axios.get(`/event/${id}`).then(response => response.data.data);
export const deleteEvent = (id) => Axios.delete(`/event/${id}`);

// calender 
export const getCalenderEventList = (data) => Axios.get(`/common/calender`, { params: data }).then(response => {
  // API returns: { message: "...", calendar: { data: [...] } }
  return response.data.calendar?.data || response.data.data || [];
});
